var _defs, _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSoundOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_19372",
    "data-name": "Group 19372",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.988,
    height: 19.452,
    viewBox: "0 0 22.988 19.452",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7530",
    "data-name": "Path 7530",
    className: "cls-1",
    d: "M35.487,25.258a.676.676,0,0,0-.7.039l-6.821,4.639h-3.2A2.965,2.965,0,0,0,21.81,32.9v4.016a2.965,2.965,0,0,0,2.962,2.962h3.2l6.821,4.639a.669.669,0,0,0,.38.118.691.691,0,0,0,.317-.078.676.676,0,0,0,.36-.6v-18.1A.669.669,0,0,0,35.487,25.258Zm-1,17.411-5.936-4.035a.669.669,0,0,0-.38-.118H24.768a1.6,1.6,0,0,1-1.6-1.6v-4.02a1.6,1.6,0,0,1,1.6-1.6h3.409a.651.651,0,0,0,.38-.118l5.936-4.035Z",
    transform: "translate(-21.81 -25.18)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18680",
    "data-name": "Rectangle 18680",
    className: "cls-1",
    width: 1.567,
    height: 7.836,
    rx: 0.784,
    transform: "translate(21.88 6.402) rotate(45)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18681",
    "data-name": "Rectangle 18681",
    className: "cls-1",
    width: 1.567,
    height: 7.836,
    rx: 0.784,
    transform: "translate(22.988 11.942) rotate(135)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSoundOff);
export default __webpack_public_path__ + "static/media/Icon_SoundOFF.be50b700eb49e8915e57fe8612f44d2c.svg";
export { ForwardRef as ReactComponent };